export default __webpack_public_path__ + "static/media/login-icon.e856d6ac.png";